import { UnreachableCaseError } from 'ts-essentials';
import {
  ChartSortEnum,
  IChartSettings,
  IDisplayedMeasureSetting,
} from '../../../components/Chart/interfaces';
import { IMeasureControl } from '../../../utils/apollo/graphqlSchema';
import { IDataTableAnalysis } from '../../../utils/apollo/responseTypes';
import {
  defaultTableSettings,
  initialChartSettings,
  mapMeasureControl,
} from './utils';
import { CHART_TYPES } from '../../../components/Chart/constants/chartTypes';

const generateDataTableDisplayedMeasures = (
  dataTable: IDataTableAnalysis,
): IDisplayedMeasureSetting[] => {
  const measureControls: IMeasureControl[] =
    dataTable.chartControl.measureControls;

  return dataTable.query.measures.map((measure, index) => {
    const type = measure.__typename;
    const measureControl = measureControls[index];

    if (type === 'SimpleMeasure' || type === 'CompoundMeasure') {
      return {
        ...mapMeasureControl({
          measureControl,
          format: measure?.format,
        }),
        isVisible: true,
      };
    } else {
      throw new UnreachableCaseError(type);
    }
  });
};

export const generateDataTableDefaultSettings = (
  analysis: IDataTableAnalysis,
): IChartSettings => {
  const displayedMeasureSettings = generateDataTableDisplayedMeasures(analysis);
  return {
    ...initialChartSettings,
    chartType: CHART_TYPES.DATA_TABLE,
    sort: ChartSortEnum.NONE,
    displayedMeasureSettings,
    tableSettings: defaultTableSettings,
  };
};
